import { INK } from '../themeConstants'

const railRetryLabel = {
  fontWeight: 'var(--app-font-weight-medium)',
  lineHeight: '20px',
  color: 'text.primary',
}

export const muiComponentsButtonVariants = {
  MuiButton: {
    variants: [
      {
        props: { variant: 'contained', color: 'primary' },
        style: {
          borderRadius: '9999px',
          backgroundColor: '#2b2b2b',
          color: '#fff',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#1a1a1a',
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            color: INK.quaternary,
          },
        },
      },
      {
        props: { variant: 'railRetryNews' },
        style: {
          marginTop: 4,
          padding: '4px 12px',
          minWidth: 'auto',
          textTransform: 'none',
          borderRadius: '9999px',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          boxShadow: 'none',
          ...railRetryLabel,
          '&:hover': { backgroundColor: 'action.hover', boxShadow: 'none' },
        },
      },
    ],
  },
}
